// extracted by mini-css-extract-plugin
module.exports = {"tag":"previewItem_tag__xSLM-","new":"previewItem_new__HX4AI"};